import { PropsWithChildren } from 'react';
import { withCssSelector } from '../shared/withCssSelector';
import { GridLayoutRoot } from './GridLayout.styled';
import { Columns, ColumnOptions } from './GridLayout.props';

export type GridLayoutProps = {
	columns?: Columns;
	mobileColumns?: Columns;
	gap?: number;
};

type Props = PropsWithChildren<GridLayoutProps>;

function GridLayoutInner({ columns = ColumnOptions.two, mobileColumns = ColumnOptions.one, gap, children }: Props) {
	return (
		<GridLayoutRoot $columns={columns} $mobileColumns={mobileColumns} $gap={gap}>
			{children}
		</GridLayoutRoot>
	);
}

export const GridLayout = withCssSelector(GridLayoutInner, GridLayoutRoot.toString());
